import config from "Config";
import pluralize from "Utils/pluralize";
export default {
  communityPhrases: {
    Religion: `${pluralize(
      config.admin_state_local
    )} that stated their religious beliefs as {{community_value}}`,
    Language: `${pluralize(
      config.admin_state_local
    )} that spoke {{community_value}} at home `,
    Ancestry: `${pluralize(
      config.admin_state_local
    )} with {{community_value}} ancestry`,
    Birthplace: `${pluralize(
      config.admin_state_local
    )} born in {{community_value}}`,
  },
  "Socio–economic Characteristics": {
    Qualifications: {
      ste: [
        `At the {{year}} Census, {{max_count}} ({{total_perc}}% of all) ${pluralize(
          config.admin_state_local
        )} reported having a {{max_name}} qualification.`,
        "This variable only counts persons aged 15 years and over who stated a completed non-school qualification.",
      ],
      lga: [
        "At the {{year}} Census, {{max_count}} ({{total_perc}}% of all) people residing in {{geo_aggregation_value}} reported having a {{max_name}} qualification.",
        `This compares to {{total_perc_state}}% of all ${config.admin_state_name} residents with this level of qualification.`,
        "This variable only counts persons aged 15 years and over who stated a completed non-school qualification.",
      ],
      sed: [],
      community: [
        "At the {{year}} Census, {{max_count}} ({{total_perc}}% of all) {{community_phrase}} reported having a {{max_name}} qualification.",
        `This compares to {{total_perc_state}}% of all ${config.admin_state_name} residents with this level of qualification.`,
        "This variable only counts persons aged 15 years and over who stated a completed non-school qualification.",
      ],
    },
    Education: {
      ste: [
        `At the {{year}} Census, the type of enrolment with the highest number of ${pluralize(config.admin_state_local)} was {{max_name}} with {{max_count}} ({{total_perc}}% of all) ${config.admin_state_name} residents attending.`,
        "This variable only counts persons attending an educational institution.",
      ],
      lga: [
        "At the {{year}} Census, the type of enrolment with the highest number of residents of {{geo_aggregation_value}} was {{max_name}} with {{max_count}} ({{total_perc}}% of all) residents attending.",
        `This compares to {{total_perc_state}}% of all ${config.admin_state_name} residents attending the same type of educational institution in this level of education.`,
        "This variable only counts persons attending an educational institution.",
      ],
      sed: [
        "At the {{year}} Census, the type of enrolment with the highest number of residents of {{geo_aggregation_value}} was {{max_name}} with {{max_count}} ({{total_perc}}% of all) residents attending.",
        `This compares to {{total_perc_state}}% of all ${config.admin_state_name} residents attending the same type of educational institution in this level of education.`,
        "This variable only counts persons attending an educational institution.",
      ],
      community: [
        "At the {{year}} Census, the type of enrolment with the highest number of {{community_phrase}} was {{max_name}} with {{max_count}} ({{total_perc}}% of all) people attending.",
        `This compares to {{total_perc_state}}% of all ${config.admin_state_name} residents attending the same type of educational institution in this level of education.`,
        "This variable only counts persons attending an educational institution.",
      ],
    },
    "Labour Force Status": {
      ste: [
        `At the {{year}} Census, {{max_count}} ({{total_perc}}% of all) ${pluralize(
          config.admin_state_local
        )} reported their employment status as {{max_name}}.`,
        "This variable only counts persons aged 15 years and over.",
      ],
      lga: [
        "At the {{year}} Census, {{max_count}} ({{total_perc}}% of all) residents of {{geo_aggregation_value}} reported their employment status as {{max_name}}.",
        `This compares to {{total_perc_state}}% of all ${config.admin_state_name} residents with this employment status.`,
        "This variable only counts persons aged 15 years and over.",
      ],
      sed: [],
      community: [
        "At the {{year}} Census, {{max_count}} ({{total_perc}}% of all) {{community_phrase}} reported their employment status as {{max_name}}.",
        `This compares to {{total_perc_state}}% of all ${config.admin_state_name} residents with this employment status.`,
        "This variable only counts persons aged 15 years and over.",
      ],
    },
    Occupations: {
      ste: [
        `At the {{year}} Census, {{max_count}} ({{total_perc}}% of all) ${pluralize(
          config.admin_state_local
        )} stated their occupation as {{max_name}}.`,
        "This variable only counts employed persons aged 15 years and over.",
      ],
      lga: [
        "At the {{year}} Census, {{max_count}} ({{total_perc}}% of all) residents of {{geo_aggregation_value}} were {{max_name}}.",
        `This was compares to {{total_perc_state}}% of all ${config.admin_state_name} residents with the same occupation`,
        "This variable only counts employed persons aged 15 years and over.",
      ],
      sed: [],
      community: [
        "At the {{year}} Census, {{max_count}} ({{total_perc}}% of all) {{community_phrase}} were {{max_name}}.",
        `This was compares to {{total_perc_state}}% of all ${config.admin_state_name} residents with the same occupation.`,
        "This variable only counts employed persons aged 15 years and over.",
      ],
    },
    "Personal Income": {
      ste: [
        `At the {{year}} Census, {{max_count}} ({{total_perc}}% of all) ${pluralize(
          config.admin_state_local
        )} stated their weekly personal income as "{{max_name}}".`,
        "This variable only counts persons aged 15 years and over.",
      ],
      lga: [
        `At the {{year}} Census, {{max_count}} ({{total_perc}}% of all) residents of {{geo_aggregation_value}} stated their weekly personal income as "{{max_name}}".`,
        `This compares to {{total_perc_state}}% of people with the same personal income throughout ${config.admin_state_name}.`,
        "This variable only counts persons aged 15 years and over.",
      ],
      sed: [],
      community: [
        `At the {{year}} Census, {{max_count}} ({{total_perc}}% of all) {{community_phrase}} stated their weekly personal income as "{{max_name}}".`,
        `This compares to {{total_perc_state}}% of people with the same personal income throughout ${config.admin_state_name}.`,
        "This variable only counts persons aged 15 years and over.",
      ],
    },
    "Voluntary Work": {
      ste: [
        "Participation in voluntary work varies by age and gender.",
        `At the {{year}} Census, {{number}} ({{total_perc}}% of all) ${pluralize(
          config.admin_state_local
        )} reported participating in voluntary activities.`,
        "This variable only counts persons aged 15 years and over.",
      ],
      lga: [
        "Participation in voluntary work varies by age and gender.",
        "At the {{year}} Census, {{number}} ({{total_perc}}% of all) residents of {{geo_aggregation_value}} reported participating in voluntary activities.",
        `For ${config.admin_state_name}, the proportion is {{total_perc_state}}%.`,
        "This variable only counts persons aged 15 years and over.",
      ],
      sed: [],
      community: [
        "Participation in voluntary work varies by age and gender.",
        "At the {{year}} Census, {{number}} ({{total_perc}}% of all) {{community_phrase}} reported participating in voluntary activities.",
        `For ${config.admin_state_name}, the proportion is {{total_perc_state}}%.`,
        "This variable only counts persons aged 15 years and over.",
      ],
    },
  },
  "Households and Income": {
    "Family Composition": {
      ste: [
        `Of all ${config.admin_state_name} residents who reported living in a family household, at the {{year}} Census, {{number}} ({{total_perc}}%) reported living in a {{max_name}} family.`,
      ],
      lga: [
        `Of all residents of {{geo_aggregation_value}} who reported living in a family household, at the {{year}} Census, {{number}} ({{total_perc}}%) reported living in a {{max_name}} family.`,
        `This can be compared to the proportion of people in this type of family household throughout ${config.admin_state_name}, {{total_perc_state}}%.`,
      ],
      sed: [],
      community: [
        `Of all {{community_phrase}} who reported living in a family household, at the {{year}} Census, {{number}} ({{total_perc}}%) reported living in a {{max_name}} family.`,
        `This can be compared to the proportion of people in this type of family household throughout ${config.admin_state_name}, {{total_perc_state}}%.`,
      ],
    },
    "Children in Family": {
      ste: [
        `Of all ${config.admin_state_name} residents who reported living in a family household with children, at the {{year}} Census, {{max_count}} ({{total_perc}}%) reported living in a family with "{{max_name}}".`,
      ],
      lga: [
        `Of all residents of {{geo_aggregation_value}} who reported living in a family household with children, at the {{year}} Census, {{max_count}} ({{total_perc}}%) reported living in a family with "{{max_name}}".`,
        `This can be compared to the proportion of people in this type of family throughout ${config.admin_state_name}, {{total_perc_state}}%.`,
      ],
      sed: [],
      community: [
        `Of all {{community_phrase}} who reported living in a family household with children, at the {{year}} Census, {{max_count}} ({{total_perc}}%) reported living in a family with "{{max_name}}".`,
        `This can be compared to the proportion of people in this type of family throughout ${config.admin_state_name}, {{total_perc_state}}%.`,
      ],
    },
    "Residents in Dwelling": {
      ste: [
        `At the {{year}} Census, {{max_count}} ({{total_perc}}% of all) ${config.admin_state_name} residents living in a private dwelling lived in a {{max_name}} household.`,
      ],
      lga: [
        "At the {{year}} Census, {{max_count}} ({{total_perc}}% of all) residents of {{geo_aggregation_value}} living in a private dwelling lived in a household with {{max_name}}.",
        `This compares to {{total_perc_state}}% of people living in a household with {{max_name}} throughout ${config.admin_state_name}.`,
      ],
      sed: [],
      community: [
        "At the {{year}} Census, {{max_count}} ({{total_perc}}% of all) {{community_phrase}} living in a private dwelling lived in a household with {{max_name}}.",
        `This compares to {{total_perc_state}}% of people living in a household with {{max_name}} throughout ${config.admin_state_name}.`,
      ],
    },
    "Household Income": {
      ste: [
        `At the {{year}} Census, {{max_count}} ({{total_perc}}% of all) ${pluralize(
          config.admin_state_local
        )} living in a private dwelling reported their total weekly household income as {{max_name}}.`,
      ],
      lga: [
        "At the {{year}} Census, {{max_count}} ({{total_perc}}% of all) residents of {{geo_aggregation_value}} living in a private dwelling stated their weekly household income as {{max_name}}.",
        `This compares to {{total_perc_state}}% of people with the same household income throughout ${config.admin_state_name}.`,
      ],
      sed: [],
      community: [
        "At the {{year}} Census, {{max_count}} ({{total_perc}}% of all) {{community_phrase}} living in a private dwelling stated their weekly household income as {{max_name}}.",
        `This compares to {{total_perc_state}}% of people with the same household income throughout ${config.admin_state_name}.`,
      ],
    },
    "Internet Access": {
      ste: [
        `At the {{year}} Census, {{max_count}} ({{total_perc}}% of all) ${pluralize(
          config.admin_state_local
        )} living in a private dwelling reported "{{max_name}}" when asked about their internet connectivity.`,
      ],
      lga: [
        `At the {{year}} Census, {{max_count}} ({{total_perc}}% of all) residents of {{geo_aggregation_value}} living in a private dwelling reported "{{max_name}}" when asked about their internet connectivity.`,
        `This compares with {{total_perc_state}}% for all ${pluralize(
          config.admin_state_local
        )} living in a private dwelling.`,
      ],
      sed: [],
      community: [
        `At the {{year}} Census, {{max_count}} ({{total_perc}}% of all) {{community_phrase}} living in a private dwelling reported "{{max_name}}" when asked about their internet connectivity.`,
        `This compares with {{total_perc_state}}% for all ${pluralize(
          config.admin_state_local
        )} living in a private dwelling.`,
      ],
    },
    "Socioeconomic disadvantage (SEIFA)": {
      ste: [
        `At the {{year}} Census, {{max_count}} ({{total_perc}}% of all) ${pluralize(
          config.admin_state_local
        )} were in {{max_name}} of the SEIFA index for relative social disadvantage (population-based).`,
      ],
      lga: [
        "At the {{year}} Census, {{max_count}} ({{total_perc}}% of all) residents of {{geo_aggregation_value}} were in {{max_name}} of the SEIFA index for relative social disadvantage (population-based).",
      ],
      sed: [],
      community: [
        "At the {{year}} Census, {{max_count}} ({{total_perc}}% of all) {{community_phrase}} were in {{max_name}} of the SEIFA index for relative social disadvantage (population-based).",
      ],
    },
  },
  "Key Statistics": {
    "Population Composition": {
      ste: [
        // `At the {{year}} Census, the population of ${config.admin_state_name} was {{total}}.`
      ],
      lga: [
        // "At the {{year}} Census, the population of {{geo_aggregation_value}} was {{total}}. This was {{total_perc}}% of the total State population."
      ],
      sed: [
        // "At the {{year}} Census, the population of {{geo_aggregation_value}} was {{total}}. This was {{total_perc}}% of the total State population."
      ],
      community: [
        "At the {{year}} Census, the population of {{community_phrase}} was {{total}}, {{total_perc}}% of the total State population.",
      ],
    },
    "Age and Gender": {
      ste: [
        `There were {{total}} people living in ${config.admin_state_name} at the {{year}} Census.`,
        "There were {{total_male}} ({{prct_male}}%) males and {{total_female}} ({{prct_female}}%) females.",
        "The most common age group was {{max_name}} with {{max_count}} ({{max_perc}}%) people."
      ],
      lga: [
        "There were {{total}} people living in {{geo_aggregation_value}} at the {{year}} Census.",
        "There were {{total_male}} ({{prct_male}}%) males and {{total_female}} ({{prct_female}}%) females.",
        "The most common age group was {{max_name}} with {{max_count}} ({{max_perc}}% of all) people, this compares to {{total_perc_state}}% of the total State population."
      ],
      sed: [
        "There were {{total}} people living in {{geo_aggregation_value}} at the {{year}} Census.",
        "There were {{total_male}} ({{prct_male}}%) males and {{total_female}} ({{prct_female}}%) females.",
        "The most common age group was {{max_name}} with {{max_count}} ({{max_perc}}% of all) people, this compares to {{total_perc_state}}% of the total State population."
      ],
      community: [
        "There were {{total}} {{community_phrase}} at the {{year}} Census.",
        "There were {{total_male}} ({{prct_male}}%) males and {{total_female}} ({{prct_female}}%) females.",
        "The most common age group was {{max_name}} with {{max_count}} ({{max_perc}}% of all) people, this compares to {{total_perc_state}}% of the total State population."
      ],
    },
    "Service Age Groups": {
      ste: [ 
        "The age ranges on this page represent useful aggregations of five year age groups.",
        `The most common service age group was {{max_name}} with {{max_count}} ({{total_perc}}% of all ${pluralize(config.admin_state_local)}).`
      ],
      lga: [
        "The age ranges on this page represent useful aggregations of five year age groups.",
        "The most common service age group was {{max_name}} with {{max_count}} ({{total_perc}}% of all residents of {{geo_aggregation_value}}).",
      ],
      sed: [
        "The age ranges on this page represent useful aggregations of five year age groups.",
        "The most common service age group was {{max_name}} with {{max_count}} ({{total_perc}}% of all residents of {{geo_aggregation_value}}).",
      ],
      community: [
        "The age ranges on this page represent useful aggregations of five year age groups.",
        "The most common service age group was {{max_name}} with {{max_count}} ({{total_perc}}% of all {{community_phrase}}).",
      ],
    },
    "LGA Distribution": {
      ste: [],
      lga: [],
      sed: [],
      community: [
        "At the {{year}} Census, the local government area with the most {{community_phrase}} was {{first}} ({{first_count}}/{{first_perc}}% of all). Next top ranking LGAs were {{second}} ({{second_count}}/{{second_perc}}%), and {{third}} ({{third_count}}/{{third_perc}}%).",
      ],
    },
    "Major Birthplaces": {
      ste: [
        `At the {{year}} Census, {{number_born_outside_au}} ({{total_perc}}% of all) ${config.admin_state_name} residents were born outside of Australia.`,
        "The most common birthplaces outside of Australia were {{first}} ({{first_count}}/{{first_perc}}%), {{second}} ({{second_count}}/{{second_perc}}%), and {{third}} ({{third_count}}/{{third_perc}}%).",
      ],
      lga: [
        "At the {{year}} Census, there were {{number_born_outside_au}} ({{total_perc}}% of all) residents of {{geo_aggregation_value}} who were born outside of Australia.",
        "This compares to {{total_perc_state}}% of the total State population.",
        "The most common birthplaces outside of Australia were {{first}} ({{first_count}}/{{first_perc}}%), {{second}} ({{second_count}}/{{second_perc}}%), and {{third}} ({{third_count}}/{{third_perc}}%).",
      ],
      sed: [
        "At the {{year}} Census, there were {{number_born_outside_au}} ({{total_perc}}% of all) residents of {{geo_aggregation_value}} who were born outside of Australia.",
        "This compares to {{total_perc_state}}% of the total State population.",
        "The most common birthplaces outside of Australia were {{first}} ({{first_count}}/{{first_perc}}%), {{second}} ({{second_count}}/{{second_perc}}%), and {{third}} ({{third_count}}/{{third_perc}}%).",
      ],
      community: [
        "At the {{year}} Census, there were {{number_born_outside_au}} ({{total_perc}}% of all) {{community_phrase}} who were born outside of Australia.",
        "This compares to {{total_perc_state}}% of the total State population.",
        "The most common birthplaces outside of Australia were {{first}} ({{first_count}}/{{first_perc}}%), {{second}} ({{second_count}}/{{second_perc}}%), and {{third}} ({{third_count}}/{{third_perc}}%).",
      ],
    },
    "Indigenous Status": {
      ste: [
        `At the {{year}} Census, there were {{total}} ({{total_perc}}% of all) ${config.admin_state_name} residents who identified themselves as being of Aboriginal and/or Torres Strait Islander descent.`,
      ],
      lga: [
        "At the {{year}} Census, there were {{total}} ({{total_perc}}% of all) residents of {{geo_aggregation_value}} who identified themselves as being of Aboriginal and/or Torres Strait Islander descent.",
        "This compares to {{total_perc_state}}% of the total State population.",
      ],
      sed: [
        "At the {{year}} Census, there were {{total}} ({{total_perc}}% of all) residents of {{geo_aggregation_value}} who identified themselves as being of Aboriginal and/or Torres Strait Islander descent.",
        "This compares to {{total_perc_state}}% of the total State population.",
      ],
      community: [
        "At the {{year}} Census, {{total}} ({{total_perc}}% of all) {{community_phrase}} identified themselves as being of Aboriginal and/or Torres Strait Islander descent.",
        "This compares to {{total_perc_state}}% of the total State population.",
      ],
    },
    "Born Overseas": {
      ste: [
        `At the {{year}} Census, {{total_os}} ({{total_pct_os}}% of all) ${config.admin_state_name} residents were born overseas, while {{total_pct_au}}% were born in Australia.`,
      ],
      lga: [
        "At the {{year}} Census, {{total_os}} ({{total_pct_os}}% of all) residents in {{geo_aggregation_value}} were born overseas, while {{total_pct_au}}% were born in Australia.",
        "This compares to {{total_pct_state_os}}% of the total State population born overseas.",
      ],
      sed: [
        "At the {{year}} Census, {{total_os}} ({{total_pct_os}}% of all) residents in {{geo_aggregation_value}} were born overseas, while {{total_pct_au}}% were born in Australia.",
        "This compares to {{total_pct_state_os}}% of the total State population born overseas.",
      ],
      community: [
        "At the {{year}} Census, {{total_os}} ({{total_pct_os}}% of all) {{community_phrase}} were born overseas, while {{total_pct_au}}% were born in Australia.",
        "This compares to {{total_pct_state_os}}% of the total State population born overseas.",
      ],
    },
    "Born in MES and NMES countries": {
      ste: [
        `At the {{year}} Census, {{total_mes}} ({{total_perc_mes}}% of all) ${config.admin_state_name} residents were born in main English speaking (MES) countries, while {{total_perc_nmes}}% were born in non-main English speaking countries.`,
      ],
      lga: [
        "At the {{year}} Census, {{total_mes}} ({{total_perc_mes}}% of all) residents of {{geo_aggregation_value}} were born in main English speaking (MES) countries, while {{total_perc_nmes}}% were born in non-main English speaking countries.",
        "This compares to {{total_perc_state_mes}}% of the total State population born in MES countries and {{total_perc_state_nmes}}% born in non-MES countries.",
      ],
      sed: [
        "At the {{year}} Census, {{total_mes}} ({{total_perc_mes}}% of all) residents of {{geo_aggregation_value}} were born in main English speaking (MES) countries, while {{total_perc_nmes}}% were born in non-main English speaking countries.",
        "This compares to {{total_perc_state_mes}}% of the total State population born in MES countries and {{total_perc_state_nmes}}% born in non-MES countries.",
      ],
      community: [
        "At the {{year}} Census, {{total_mes}} ({{total_perc_mes}}% of all) {{community_phrase}} were born in main English speaking (MES) countries, while {{total_perc_nmes}}% were born in non-main English speaking countries.",
        "This compares to {{total_perc_state_mes}}% of the total State population born in MES countries and {{total_perc_state_nmes}}% born in non-MES countries.",
      ],
    },
    "Year of Arrival": {
      ste: [
        "The Census first recorded arrivals into Australia in {{first_year}}. The year of arrival in which the greatest number of new residents entered Australia was {{max_year}}, when {{max_amount}} people arrived.",
      ],
      lga: [
        "The Census first recorded arrivals of residents of {{geo_aggregation_value}} into Australia in {{first_year}}. At the time of the {{year}} Census, there were {{max_amount}} overseas-born residents of {{geo_aggregation_value}} who first arrived in Australia in {{max_year}}.",
      ],
      sed: [
        "The Census first recorded arrivals of residents of {{geo_aggregation_value}} into Australia in {{first_year}}. At the time of the {{year}} Census, there were {{max_amount}} overseas-born residents of {{geo_aggregation_value}} who first arrived in Australia in {{max_year}}.",
      ],
      community: [
        "The Census first recorded arrivals of {{community_phrase}} into Australia in {{first_year}}. The year of arrival in which the greatest number of {{community_phrase}} came to Australia was {{max_year}}, when {{max_amount}} people arrived.",
      ],
    },
    Citizenship: {
      ste: [
        `At the {{year}} Census, {{total_aussies}} ({{pct_aussies}}% of all) ${pluralize(
          config.admin_state_local
        )} reported being Australian citizens.`,
      ],
      lga: [
        "At the {{year}} Census, {{total_aussies}} ({{pct_aussies}}% of all) residents of {{geo_aggregation_value}} reported being Australian citizens.",
        "This compares to {{pct_aussies_state}}% of the total State population.",
      ],
      sed: [
        "At the {{year}} Census, {{total_aussies}} ({{pct_aussies}}% of all) residents of {{geo_aggregation_value}} reported being Australian citizens.",
        "This compares to {{pct_aussies_state}}% of the total State population.",
      ],
      community: [
        "At the {{year}} Census, {{total_aussies}} ({{pct_aussies}}% of all) {{community_phrase}} reported being Australian citizens.",
        "This compares to {{pct_aussies_state}}% of the total State population.",
      ],
    },
  },
  "Cultural, Linguistic and Religious Backgrounds": {
    Ancestry: {
      ste: [
        "At the {{year}} Census, there were {{max_amount}} ({{total_perc}}% of all) reports of {{max_ancestry}} ancestry across the State.",
        "The next most common reported ancestries were {{second}} ({{second_count}}/{{second_perc}}%), and {{third}} ({{third_count}}/{{third_perc}}%).",
        "This variable counts all total reported ancestries. Each person can report up to two. This means the total count of reports will not match the total population.",
      ],
      lga: [
        "At the {{year}} Census, there were {{max_amount}} ({{total_perc}}% of all) reports of {{max_ancestry}} ancestry across {{geo_aggregation_value}}.",
        "This compares to {{total_perc_state}}% of the total State ancestry reports.",
        "The next most common reported ancestries were {{second}} ({{second_count}}/{{second_perc}}%), and {{third}} ({{third_count}}/{{third_perc}}%).",
        "This variable counts all total reported ancestries. Each person can report up to two. This means the total count of reports will not match the total population.",
      ],
      sed: [
        "At the {{year}} Census, there were {{max_amount}} ({{total_perc}}% of all) reports of {{max_ancestry}} ancestry across {{geo_aggregation_value}}.",
        "This compares to {{total_perc_state}}% of the total State ancestry reports.",
        "The next most common reported ancestries were {{second}} ({{second_count}}/{{second_perc}}%), and {{third}} ({{third_count}}/{{third_perc}}%).",
        "This variable counts all total reported ancestries. Each person can report up to two. This means the total count of reports will not match the total population.",
      ],
      community: [
        "At the {{year}} Census, there were {{max_amount}} ({{total_perc}}% of all) reports of {{max_ancestry}} ancestry among {{community_phrase}}.",
        "This compares to {{total_perc_state}}% of the total State ancestry reports.",
        "The next most common reported ancestries were {{second}} ({{second_count}}/{{second_perc}}%), and {{third}} ({{third_count}}/{{third_perc}}%).",
        "This variable counts all total reported ancestries. Each person can report up to two. This means the total count of reports will not match the total population.",
      ],
    },
    "LOTE Speakers": {
      ste: [
        `At the {{year}} Census, there were {{total_not_english}} ({{pct_not_english}}% of all) residents of ${config.admin_state_name} who spoke a language other than English.`,
      ],
      lga: [
        "At the {{year}} Census, there were {{total_not_english}} ({{pct_not_english}}% of all) residents of {{geo_aggregation_value}} who spoke a language other than English.",
        "This compares to {{pct_not_english_state}}% of the total State population.",
      ],
      sed: [
        "At the {{year}} Census, there were {{total_not_english}} ({{pct_not_english}}% of all) residents of {{geo_aggregation_value}} who spoke a language other than English.",
        "This compares {{pct_not_english_state}}% of the total State population.",
      ],
      community: [
        "At the {{year}} Census, there were {{total_not_english}} ({{pct_not_english}}% of all) {{community_phrase}} who spoke a language other than English.",
        "This compares to {{pct_not_english_state}}% of the total State population.",
      ],
    },
    "Languages Spoken at Home": {
      ste: [
        `At the {{year}} Census, there were {{max_total}} ({{total_perc}}% of all) residents living in ${config.admin_state_name} who spoke {{max_language}} at home.`,
        "The next most common languages were {{second}} ({{second_count}}/{{second_perc}}%), and {{third}} ({{third_count}}/{{third_perc}}%).",
      ],
      lga: [
        "At the {{year}} Census, there were {{max_total}} ({{total_perc}}% of all) residents living in {{geo_aggregation_value}} who spoke {{max_language}} at home.",
        "This compares to {{total_perc_state}}% of the total State population.",
        "The next most common languages were {{second}} ({{second_count}}/{{second_perc}}%), and {{third}} ({{third_count}}/{{third_perc}}%).",
      ],
      sed: [
        "At the {{year}} Census, there were {{max_total}} ({{total_perc}}% of all) residents living in {{geo_aggregation_value}} who spoke {{max_language}} at home.",
        "This compares to {{total_perc_state}}% of the total State population.",
        "The next most common languages were {{second}} ({{second_count}}/{{second_perc}}%), and {{third}} ({{third_count}}/{{third_perc}}%).",
      ],
      community: [
        "At the {{year}} Census, there were {{max_total}} ({{total_perc}}% of all) {{community_phrase}} who spoke {{max_language}} at home.",
        "This compares to {{total_perc_state}}% of the total State population.",
        "The next most common languages were {{second}} ({{second_count}}/{{second_perc}}%), and {{third}} ({{third_count}}/{{third_perc}}%).",
      ]
    },
    "Proficiency in English": {
      ste: [
        `Of all ${pluralize(config.admin_state_local)} who reported speaking a language other than English at the {{year}} Census, {{proficient_total}} ({{total_pct}}%) reported speaking English very well or well.`,
      ],
      lga: [
        "Of all residents of {{geo_aggregation_value}} who reported speaking a language other than English at the {{year}} Census, {{proficient_total}} ({{total_pct}}%) reported speaking English very well or well.",
        "This compares to {{total_pct_state}}% of the total State population that spoke a language other than English.",
      ],
      sed: [
        "Of all residents of {{geo_aggregation_value}} who reported speaking a language other than English at the {{year}} Census, {{proficient_total}} ({{total_pct}}%) reported speaking English very well or well.",
        "This compares to {{total_pct_state}}% of the total State population that spoke a language other than English.",
      ],
      community: [
        "Of all {{community_phrase}} who reported speaking a language other than English at the {{year}} Census, {{proficient_total}} ({{total_pct}}%) reported speaking English very well or well.",
        "This compares to {{total_pct_state}}% of the total State population that spoke a language other than English.",
      ],
    },
    "Religious Affiliation": {
      ste: [
        `At the {{year}} Census, {{max_amount}} ({{total_perc}}% of all) ${pluralize(config.admin_state_local)} reported their religious beliefs as {{max_religion}}.`,
        "The next most common beliefs were {{second}} ({{second_count}}/{{second_perc}}%), and {{third}} ({{third_count}}/{{third_perc}}%).",
      ],
      lga: [
        "At the {{year}} Census, {{max_amount}} ({{total_perc}}% of all) residents of {{geo_aggregation_value}} reported their religious beliefs as {{max_religion}}.",
        "This compares to {{total_perc_state}}% of the total State population.",
        "The next most common beliefs were {{second}} ({{second_count}}/{{second_perc}}%), and {{third}} ({{third_count}}/{{third_perc}}%).",
      ],
      sed: [
        "At the {{year}} Census, {{max_amount}} ({{total_perc}}% of all) residents of {{geo_aggregation_value}} reported their religious beliefs as {{max_religion}}.",
        "This compares to {{total_perc_state}}% of the total State population.",
        "The next most common beliefs were {{second}} ({{second_count}}/{{second_perc}}%), and {{third}} ({{third_count}}/{{third_perc}}%).",
      ],
      community: [
        "At the {{year}} Census, {{max_amount}} ({{total_perc}}% of all) {{community_phrase}} reported their religious beliefs as {{max_religion}}.",
        "This compares to {{total_perc_state}}% of the total State population.",
        "The next most common beliefs were {{second}} ({{second_count}}/{{second_perc}}%), and {{third}} ({{third_count}}/{{third_perc}}%).",
      ],
    },
  },
  "Disability and Unpaid Care": {
    Disability: {
      ste: [
        `At the {{year}} Census, {{total_count}} ({{total_perc}}% of all) ${pluralize(
          config.admin_state_local
        )} reported having a need for assistance with core activities relating to self-care, communication and mobility.`,
        "The need for assistance increases with age, and generally is seen in high numbers for people aged 65 years and over.",
        //"Males were {{male_pct}}% of people in need of assistance, while females were {{female_pct}}%.",
      ],
      lga: [
        "At the {{year}} Census, {{total_count}} ({{total_perc}}% of all) residents of {{geo_aggregation_value}} reported having a need for assistance with core activities relating to self-care, communication and mobility.",
        `This compares with {{total_perc_state}}% for all of ${config.admin_state_name}.`,
        "The need for assistance increases with age, and generally is seen in high numbers for people aged 65 years and over.",
       // "Males were {{male_pct}}% of people in need of assistance, while females were {{female_pct}}%.",
      ],
      sed: [],
      community: [
        "At the {{year}} Census, {{total_count}} ({{total_perc}}% of all) {{community_phrase}} reported having a need for assistance with core activities relating to self-care, communication and mobility.",
        `This compares with {{total_perc_state}}% for all of ${config.admin_state_name}.`,
        "The need for assistance increases with age, and generally is seen in high numbers for people aged 65 years and over.",
        //"Males were {{male_pct}}% of people in need of assistance, while females were {{female_pct}}%.",
      ],
    },
    "Unpaid Care": {
      ste: [
        `At the {{year}} Census, {{total_count}} ({{total_perc}}% of all) ${pluralize(
          config.admin_state_local
        )} over the age of 15 reported themselves as having provided unpaid care to another individual with a disability.`,
        //"Males were {{male_pct}}% of people providing unpaid care, while females were {{female_pct}}%.",
        //"This variable only counts persons aged 15 years and over.",
      ],
      lga: [
        "At the {{year}} Census, {{total_count}} ({{total_perc}}% of all) residents of {{geo_aggregation_value}} over the age of 15 reported having provided unpaid care to another individual with a disability.",
        `This compares with {{total_perc_state}}% for all of ${config.admin_state_name}.`,
        //"Males were {{male_pct}}% of people providing unpaid care, while females were {{female_pct}}%.",
        //"This variable only counts persons aged 15 years and over.",
      ],
      sed: [],
      community: [
        "At the {{year}} Census, {{total_count}} ({{total_perc}}% of all) {{community_phrase}} over the age of 15 reported having provided unpaid care to another individual with a disability.",
        `This compares with {{total_perc_state}}% for all of ${config.admin_state_name}.`,
        //"Males were {{male_pct}}% of people providing unpaid care, while females were {{female_pct}}%.",
        //"This variable only counts persons aged 15 years and over.",
      ],
    },
  },
};



// WEBPACK FOOTER //
// ../data/captions.js